<template>
  <div class="card">
    <!-- 已發布帖子 -->
    <ul class="publishedWrap">
      <li @click.stop="detailClick(cardData.id, false)">
        <!-- <li> -->
        <div class="userInfo" @click.stop="detailClick(cardData.id, false)">
          <div
            class="userInfo_leftbox"
            @click.stop="
              personalPage == '' ? goUserPage(cardData.memberId) : ''
            "
          >
            <div class="userInfo_leftbox_imgbox">
              <img :src="cardData.memberAvator" @error="defImg()" alt="" />
              <!-- <img :src="cardData.memberAvator" ref="headerimg" alt="" /> -->
              <div
                class="userInfo_leftbox_img_icon"
                :class="
                  cardData.memberAuthInfo && cardData.isOfficial == 0
                    ? 'memberAuthInfoFlag'
                    : ''
                "
                v-show="
                  cardData.isOfficial == 1 ||
                  cardData.isOfficial == 2 ||
                  cardData.memberAuthInfo
                "
              ></div>
            </div>
            <div class="usernamebox">
              <p class="username">{{ cardData.memberNickName }}</p>
              <div class="card_levelIcon" v-show="personalPage == ''">
                <levelIcon
                  :level="cardData.memberLevel"
                  v-if="$route.name != 'search'"
                ></levelIcon>
              </div>
              <div
                class="auth_icon"
                v-if="
                  cardData.memberAuthInfo &&
                  cardData.isOfficial != 1 &&
                  $store.state.gameType != 2
                "
              >
                {{ cardData.memberAuthInfo }}
              </div>
            </div>
            <p class="publishTime">{{ cardData.createTime }}</p>
          </div>
        </div>
        <div class="eventwrap" @click.stop>
          <div class="eventwrap_right" @click.stop="eventWrapClick">...</div>
        </div>
        <!-- 發布内容 -->
        <div class="publishedContent">
          <div v-if="cardData.title !== ''" class="cardTitle">
            <h2 @click.stop="detailClick(cardData.id, false)">
              <span
                class="publishedContent_spanicon"
                v-if="cardData.isOfficial == 1"
                >官</span
              >
              <span
                v-if="highLight"
                v-highlight="{
                  text: cardData.title,
                  keyword: $parent.$parent.value
                }"
              ></span>
              <span v-else>{{ cardData.title }}</span>
            </h2>
          </div>
          <div
            class="publishedCon"
            v-if="highLight"
            :class="cardData.isOfficial == 1 ? 'officialPublishedCon' : ''"
            v-highlight="{
              text: cardData.description,
              keyword: $parent.$parent.value
            }"
            @click.stop="detailClick(cardData.id, false)"
          ></div>
          <div
            class="publishedCon"
            v-else
            :class="cardData.isOfficial == 1 ? 'officialPublishedCon' : ''"
            v-text="cardData.description"
            @click.stop="detailClick(cardData.id, false)"
          ></div>
          <!-- 帖子图片或者视频  如果有视频 优先展示视频 -->
          <div
            :class="typographyImg"
            v-if="cardData.videos && cardData.videos.length < 1"
          >
            <!-- <div
              class="card_publishedContent_imgbox"
              :class="imgCross"
              v-for="(item, index) in imgList"
              :key="item.id"
              @click.stop="imgClick(true, imgList, index)"
            > -->
            <div
              class="card_publishedContent_imgbox"
              :class="imgCross"
              v-for="(item, index) in imgList"
              :key="item.id"
              @click.stop="imgClick()"
            >
              <!-- <img :src="item.path + imgThumb" alt="" /> -->
              <img
                :preview="item.class"
                :src="item.path + imgThumb"
                :large="item.path + imgThumb"
                alt=""
              />
              <div class="imgNum" v-if="imgList.length > 3 && index == 2">
                <img src="@/assets/img/xc.png" alt="" />
                <!-- <span>+</span> -->
                <p>{{ imgList.length }}</p>
              </div>
            </div>
          </div>

          <div
            class="video_post"
            v-if="cardData.videos && cardData.videos.length > 0"
          >
            <!-- <img v-if="$store.state.isInGame && $store.state.isU3d" @click="goUrl(cardData.videos[0].path)"  :data-video="cardData.videos[0].path" src="https://qa-sea-community.sugarfungame.com/img/header_bg.31f63036.jpg"  > -->
            <myVideo
              :id="'video' + cardData.id"
              :ref="'video' + cardData.id"
              :src="cardData.videos[0].path"
              :poster="cardData.videos[0].path + '.jpg'"
            />
          </div>
        </div>
        <!-- 帖子的话题 -->
        <div class="card_topic">
          <p
            v-for="item in cardData.subjects"
            :key="item.id"
            @click.stop="toHotPage(item)"
            v-show="item.id != subjectId || subjectId == 0"
          >
            <span> #{{ item.subjectName }} </span>
          </p>
        </div>
        <div class="publicAction" v-if="false">
          <div
            @click.stop="likeClick(cardData.id)"
            class="publicAction_item"
            :data-id="cardData.id"
          >
            <div
              class="card_lickbtn"
              :class="
                isLike || likeClickFlag
                  ? 'publicAction_curgoodicon'
                  : 'publicAction_goodicon'
              "
              ref="card_lickbtn"
            ></div>
            <p class="card_good_box">
              <span v-show="cardData.goodNum == 0" class="dz"> 点赞 </span>
              <span v-show="cardData.goodNum != 0">
                {{ cardData.goodNum }}
              </span>
            </p>
          </div>
          <div
            @click.stop="detailClick(cardData.id, true)"
            class="publicAction_item"
          >
            <div class="publicAction_commentsicon"></div>
            <p>
              <span v-show="cardData.commentNum == 0"> 评论 </span>
              <span v-show="cardData.commentNum != 0">
                {{ cardData.commentNum }}
              </span>
            </p>
          </div>
          <div
            @click.stop="shareShowFlag(true)"
            class="publicAction_item"
            v-if="true"
          >
            <div class="publicAction_turnicon"></div>
            <span>分享</span>
          </div>
        </div>
        <div
          class="publicPartitionName"
          v-if="cardData.partitionName && cardData.partitionShow"
          @click.stop="toPartition(cardData)"
        >
          <p>{{ cardData.partitionName }}</p>
        </div>
        <div class="publicActionThree">
          <div
            @click.stop="detailClick(cardData.id, true)"
            class="publicAction_item"
          >
            <div class="publicAction_commentsicon"></div>
            <p>
              <span v-show="cardData.commentNum == 0"> 评论 </span>
              <span v-show="cardData.commentNum != 0">
                {{ cardData.commentNum }}
              </span>
            </p>
          </div>
          <div
            @click.stop="likeClick(cardData.id)"
            class="publicAction_item"
            :data-id="cardData.id"
          >
            <div
              class="card_lickbtn"
              :class="
                isLike || likeClickFlag
                  ? 'publicAction_curgoodicon'
                  : 'publicAction_goodicon'
              "
              ref="card_lickbtn"
            ></div>
            <p class="card_good_box">
              <span v-show="cardData.goodNum == 0" class="dz"> 点赞 </span>
              <span v-show="cardData.goodNum != 0">
                {{ cardData.goodNum }}
              </span>
            </p>
          </div>
        </div>
      </li>
    </ul>
    <van-action-sheet v-model="shareShow" title="分享到" :round="false">
      <shareBounced
        class="content"
        :shareData="shareData"
        @shareShowFlag="shareShowFlag"
      ></shareBounced>
    </van-action-sheet>
    <largerVersion
      v-if="largerFlag"
      :largerImgList="largerImgList"
      :currindex="imgcurrindex"
      @imgClick="imgClick"
    >
    </largerVersion>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect"
      @cancel="onCancel"
      @close="close"
    />
    <van-action-sheet
      v-model="show_complaints"
      :actions="actions_complaints"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect_complaints"
      @cancel="onCancel_complaints"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import get from '@/api/get';
import qs from 'qs';
import * as _code from '../utils/code';
import isHasImg from '../utils/isHasImg';
import { Icon, ActionSheet, Toast, Dialog } from 'vant';
import largerVersion from './detailsPage/page/largerVersion.vue';
import shareBounced from './detailsPage/page/shareBounced.vue';
import levelIcon from '@/components/task/levelIcon.vue';
import myVideo from '../components/post/myVideo.vue';

import { debounce } from 'lodash';
import numberFormat from '@/utils/numberFormat';
Vue.use(ActionSheet);
export default {
  data() {
    return {
      defaultImg:
        this.$store.state.gameType != 1
          ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp'
          : 'https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png',
      shareShow: false,
      shareData: '',
      imgcurrindex: 0,
      largerFlag: false,
      largerImgList: [],
      imgCross: '',
      imgThumb: '',
      typographyImg: '',
      imgList: [],
      isLike: '',
      likeClickFlag: '',
      show: false,
      show_complaints: false,
      // actions: window.user.weixcode
      //   ? this.$store.state.memberId == this.cardData.memberId
      //     ? [
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       { name: '删除' },
      //       this.cardData.source === 'userRichText' ? { name: '编辑'} : ''
      //     ]
      //     : [
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       {
      //         name: this.cardData.isFans
      //           ? `取消关注 ${this.cardData.memberNickName}`
      //           : `关注 ${this.cardData.memberNickName}`
      //       },
      //       { name: '投诉该内容' }
      //     ]
      //   : this.$store.state.memberId == this.cardData.memberId
      //     ? [
      //       { name: '分享' },
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       {
      //         name: '删除'
      //       },
      //       this.cardData.source === 'userRichText' ? { name: '编辑'} : ''
      //     ]
      //     : [
      //       { name: '分享' },
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       {
      //         name: this.cardData.isFans
      //           ? `取消关注 ${this.cardData.memberNickName}`
      //           : `关注 ${this.cardData.memberNickName}`
      //       },
      //       { name: '投诉该内容' }
      //     ],
      actions: [],
      actions_complaints: [
        { name: '广告或垃圾消息' },
        { name: '淫秽色情' },
        { name: '政治敏感' },
        { name: '人身攻击' }
      ]
    };
  },
  props: {
    highLight: {
      type: Boolean,
      default: false
    },
    cardData: {
      type: Object,
      default: () => {}
    },
    personalPage: {
      type: String,
      default: ''
    },
    subjectId: {
      type: Number,
      default: 0
    }
  },
  components: {
    shareBounced,
    largerVersion,
    [Icon.name]: Icon,
    levelIcon,
    myVideo
  },
  computed: {
    // poster() {
    //   let src = this.cardData.videos[0].path.toLocaleLowerCase()
    //   let a = '123'
    //   if (src.includes('mp4')) {
    //     return src.replace('mp4', 'jpg')
    //   } else if (src.includes('mov')){
    //     return src.replace('mov', 'jpg')
    //   } else {
    //     return ''
    //   }
    // }
  },
  created() {
    this.cardData.description = this.cardData.description.replace(
      /\{voteid="(\d+)"value=":pas\+\{3M~Syn@G\{0"\}/g,
      ''
    );
  },
  watch: {
    cardData(n, o) {
      this.isLike = n.isLike;
      this.likeClickFlag = n.isLike;
    },
    show(n, o) {
      if (!n) {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      }
    },
    shareShow(n, o) {
      if (!n) {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      }
    },
    show_complaints(n, o) {
      if (!n) {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      }
    }
  },
  mounted() {
    let _this = this;
    this.$preview.on('close', (e, item) => {
      //图片大图关闭事件
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
    });
    this.$preview.on('imageLoadComplete', (e, item) => {
      let _preview = this.$preview.self;
      let lookUrl = window.location.href + '&look';
      window.history.pushState(null, null, lookUrl);
      _preview.listen('close', function () {
        if (window.location.href.indexOf('&look') !== -1) {
          window.history.back();
        }
      });
      window.onhashchange = function () {
        if (_preview !== null && _preview !== undefined) {
          _preview.close();
          _preview = null;
          //图片大图关闭事件
          if (_this.$store.state.system == 'iphone') {
            window.location.href =
              'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
          }
        }
      };
    });
    // isHasImg(this.$refs.headerimg)
    //   ? (this.$refs.headerimg.src = this.$refs.headerimg.src)
    //   : (this.$refs.headerimg.src =
    //       "https://media.zlongame.com/media/upload/20220303/lzg_header.png");

    // 转换帖子上传的图片
    this.cardData.pictures.forEach((item, index) => {
      // if (index < 9) {
      item['class'] = this.cardData.id;
      this.imgList.push(item);
      // }
    });
    this.$previewRefresh();
    if (this.cardData.thumbnail && this.cardData.isOfficial === 1) {
      let obj = {
        id: 0,
        class: this.cardData.id,
        path: this.cardData.thumbnail
      };
      this.imgList.push(obj);
      this.$previewRefresh();
    }
    this.isLike = this.cardData.isLike;
    this.init();
    this.imgThumb = this.$store.state.imgThumb;
    this.generateAction();
  },
  methods: {
    toPartition(item) {
      // console.log(item);
      // return;
      // console.log(item.partitionName);
      // console.log(this.$route.name);
      if (this.$route.name == 'homePage') {
        //当前页切换tab
        this.$router.push({
          name: 'partitionPage',
          query: {
            id: item.partitionId,
            subjectName: item.partitionName,
            logo: item.partitionLogo
          }
        });
      } else {
        //到分区专页
        this.$router.push({
          name: 'partitionPage',
          query: {
            id: item.partitionId,
            subjectName: item.partitionName,
            logo: item.partitionLogo
          }
        });
      }
    },
    goUrl(url) {
      // console.log('这里点击了视频')
      if (this.$store.state.isInGame && this.$store.state.isU3d) {
        // eslint-disable-next-line no-constant-condition
        // if (3 > 1) {
        var count = 3000;
        var pace = 50;
        let isQa = /^(test|qa)-/.test(location.hostname);
        let pageUrl =
          'https://' +
          (isQa ? 'qa-' : '') +
          'www.sugarfungame.com/actv/communityVideo/index.html?id=';
        setTimeout(function () {
          try {
            window.gotoUrl(pageUrl + url);
          } catch (err) {
            count = count - pace;
            if (count >= 0) {
              arguments.callee();
            }
          }
        }, pace);
      } else {
        return;
      }
    },
    generateAction() {
      let action = [];
      // window.user.weixcode
      //   ? this.$store.state.memberId == this.cardData.memberId
      //     ? [
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       { name: '删除' },
      //       this.cardData.source === 'userRichText' ? { name: '编辑' } : ''
      //     ]
      //     : [
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       {
      //         name: this.cardData.isFans
      //           ? `取消关注 ${this.cardData.memberNickName}`
      //           : `关注 ${this.cardData.memberNickName}`
      //       },
      //       { name: '投诉该内容' }
      //     ]
      //   : this.$store.state.memberId == this.cardData.memberId
      //     ? [
      //       { name: '分享' },
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       {
      //         name: '删除'
      //       },
      //       this.cardData.source === 'userRichText' ? { name: '编辑' } : ''
      //     ]
      //     : [
      //       { name: '分享' },
      //       { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
      //       {
      //         name: this.cardData.isFans
      //           ? `取消关注 ${this.cardData.memberNickName}`
      //           : `关注 ${this.cardData.memberNickName}`
      //       },
      //       { name: '投诉该内容' }
      //     ]
      if (window.user.weixcode) {
        if (this.$store.state.memberId == this.cardData.memberId) {
          if (this.cardData.source === 'userRichText') {
            action = [
              { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
              { name: '编辑' },
              { name: '删除' }
            ];
          } else {
            action = [
              { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
              { name: '删除' }
            ];
          }
        } else {
          action = [
            { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
            {
              name: this.cardData.isFans
                ? `取消关注 ${this.cardData.memberNickName}`
                : `关注 ${this.cardData.memberNickName}`
            },
            { name: '投诉该内容' }
          ];
        }
      } else {
        if (this.$store.state.memberId == this.cardData.memberId) {
          if (this.cardData.source === 'userRichText') {
            action = [
              { name: '分享' },
              { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
              { name: '编辑' },
              { name: '删除' }
            ];
          } else {
            action = [
              { name: '分享' },
              { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
              {
                name: '删除'
              }
            ];
          }
        } else {
          action = [
            { name: '分享' },
            { name: this.cardData.isFavor ? '取消收藏' : '收藏' },
            {
              name: this.cardData.isFans
                ? `取消关注 ${this.cardData.memberNickName}`
                : `关注 ${this.cardData.memberNickName}`
            },
            { name: '投诉该内容' }
          ];
        }
      }
      this.actions = action;
    },
    init() {
      // 评论、点赞数显示
      this.cardData.commentNum = numberFormat(this.cardData.commentNum);
      this.cardData.goodNum = numberFormat(this.cardData.goodNum);
      //图片初始化展示
      let _this = this;
      if (JSON.stringify(this.imgList) != '[]') {
        if (_this.imgList.length == 1) {
          //3.0版本隐藏
          let img = new Image();
          img.src = _this.imgList[0].path;
          img.onload = function () {
            if (img.height >= img.width) {
              _this.imgCross = 'card_publishedContent_imgboxVertical';
            } else {
              _this.imgCross = 'card_publishedContent_imgboxCross';
            }
            // _this.imgCross = 'card_publishedContent_imgboxCross'
          };
          // 3.0隐藏
        } else if (_this.imgList.length == 2) {
          this.typographyImg =
            'card_publishedContent_imgbigboxFour card_publishedContent_imgboxT';
          this.imgCross = 'card_publishedContent_imgboxFour';
        } else if (_this.imgList.length == 4) {
          this.typographyImg = 'card_publishedContent_imgbigboxFour';
          this.imgCross = 'card_publishedContent_imgboxFour';
        } else {
          this.typographyImg = 'card_publishedContent_imgbigbox';
          this.imgCross = 'card_publishedContent_imgboxFour';
        }
      }
    },
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //点击图片全屏
    imgClick(flag, list, index) {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
      }
      // if (flag) {
      //   this.largerImgList = list;
      //   this.imgcurrindex = index;
      //   this.largerFlag = flag;
      //   if (this.$store.state.system == "iphone") {
      //     window.location.href = "iosn://pd_bbs_actv_hideClose?hideCloseFlag=1";
      //   }
      // } else {
      //   this.largerFlag = flag;
      //   if (this.$store.state.system == "iphone") {
      //     window.location.href = "iosn://pd_bbs_actv_hideClose?hideCloseFlag=0";
      //   }
      // }
    },
    //去用户主页
    goUserPage(id) {
      this.$router.push({ name: 'otherHome', query: { id: id } });
    },
    dosomething: function () {},
    //分享弹出框显示及关闭
    shareShowFlag(flag) {
      // if (this.$store.state.loginStatus == 0) {
      //   this.$store.commit('changeLoginShow', true);
      // } else {
      this.shareData = this.cardData;
      this.shareShow = flag;
      // }
    },
    // 。。。
    eventWrapClick() {
      this.show = true;
      $('.quickRelease').hide();
    },
    //
    close() {
      $('.quickRelease').show();
    },
    //底部弹出框点击
    onSelect(item, e) {
      this.show = false;
      // Toast(item.name);
      this.show = false;
      switch (true) {
        case item.name == '分享':
          // Toast("分享");
          // if (this.$store.state.loginStatus == 0) {
          //   this.$store.commit('changeLoginShow', true);
          // } else {
          // }
          this.shareData = this.cardData;
          this.shareShowFlag(true);
          break;
        case item.name == '取消收藏' || item.name == '收藏':
          this.favor();
          break;
        case item.name == `关注 ${this.cardData.memberNickName}` ||
          item.name == `取消关注 ${this.cardData.memberNickName}`:
          this.focusClick();
          break;
        case item.name == '投诉该内容':
          this.show_complaints = true;
          break;
        case item.name == '删除':
          this.onSelect_delete();
          break;
        case item.name == '编辑':
          this.onEditPost();
          break;
        default:
          break;
      }
    },
    //底部弹出框点击——举报
    onSelect_complaints(item) {
      let obj = {
        content: item.name,
        type: 1,
        originType: 1,
        originId: this.cardData.id
      };
      get.report(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          Toast('举报成功');
        } else {
          this.errorMessage(data.code);
        }
      });
    },
    //底部弹出框点击——删除
    onSelect_delete() {
      let _this = this;
      //删除帖子
      Dialog.confirm({
        message: '确认删除该帖吗'
      })
        .then(() => {
          get.deletePost(this.cardData.id).then((res) => {
            _this.$emit('removeCardCommon');
            Toast('成功');
          });
        })
        .catch(() => {});
    },
    onCancel() {
      event.stopPropagation();
      Toast('取消');
    },
    onCancel_complaints() {
      event.stopPropagation();
      Toast('取消');
    },
    onEditPost() {
      console.log('点击了编辑');
      // 拿到cardId 和 类型，跳转对应编辑器
      if (this.cardData.source === 'userRichText') {
        if (!this.$store.state.isMobile) {
          this.$router.push({
            path: '/rich2',
            query: { postId: this.cardData.id }
          });
        } else {
          this.$router.push({
            path: '/rich',
            query: { postId: this.cardData.id }
          });
        }
      } else {
        this.$router.push({
          path: '/postPage',
          query: { postId: this.cardData.id }
        });
      }
      // this.$router.push('/')
    },
    //关注&取关
    focusClick() {
      get.follow(this.cardData.memberId).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.cardData.isFans = !this.cardData.isFans;
          this.cardData.isFans
            ? (this.actions[2].name = `取消关注 ${this.cardData.memberNickName}`)
            : (this.actions[2].name = `关注 ${this.cardData.memberNickName}`);
          Toast(data.message);
          this.$emit('firstLoad');
        } else {
          this.errorMessage(data);
        }
      });
    },
    //收藏
    favor() {
      get.favor(this.cardData.id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          let mes = '';
          this.cardData.isFavor = !this.cardData.isFavor;
          this.cardData.isFavor ? (mes = '收藏成功') : (mes = '取消收藏成功');
          Toast(mes);
          this.cardData.isFavor
            ? (this.actions[1].name = '取消收藏')
            : (this.actions[1].name = '收藏');
          this.$emit('init');
        } else {
          this.errorMessage(data.code);
        }
      });
    },
    likeChang() {
      this.likeClickFlag = this.isLike == 1 ? true : false;
      this.isLike = this.isLike == 1 ? 0 : 1;
      this.likeClickFlag = !this.likeClickFlag;
      if (!this.isLike) {
        this.cardData.goodNum =
          this.cardData.goodNum-- <= 0 ? 0 : this.cardData.goodNum--;
      } else {
        this.cardData.goodNum++;
      }
    },
    // 点赞
    likeClick: debounce(
      function (id) {
        let likeId = {
          id: id
        };
        get.likeClick(likeId.id).then((res) => {
          if (res.data.code == 0) {
            if (res.data.message == '点赞成功') {
              this.$refs.card_lickbtn.style.width = '.8rem';
              this.$refs.card_lickbtn.style.height = '.8rem';
              this.$refs.card_lickbtn.style.backgroundPosition = 'right';
              this.$refs.card_lickbtn.style.transition = `background .6s steps(28)`;
              setTimeout(() => {
                this.$refs.card_lickbtn.style.width = '.8rem';
                this.$refs.card_lickbtn.style.height = '.8rem';
                this.$refs.card_lickbtn.style.backgroundPosition = 'left';
                this.$refs.card_lickbtn.style.width = '.8rem';
                this.$refs.card_lickbtn.style.height = '.8rem';
                this.$refs.card_lickbtn.style.backgroundPosition = 'left';
                this.$refs.card_lickbtn.style.transition = `none`;
                this.likeChang();
              }, 600);
            } else {
              this.likeChang();
            }
            // this.likeChang();
          } else {
            this.errorMessage(res.data);
          }
        });
      },
      500,
      {
        leading: true,
        trailing: false
      }
    ),
    detailClick(id, anchorFlag) {
      let _path = anchorFlag
        ? '../topicPage/?topicId=' + id + '&anchor=true&isGame=true'
        : '../topicPage/?topicId=' + id + '&isGame=true';
      this.$store.commit('changeAnchorFlag', anchorFlag);
      this.$router.push({
        path: _path
      });
      if (this.cardData.videos && this.cardData.videos.length > 0) {
        if (this.$store.state.isInGame && this.$store.state.isU3d) return;
        const currentTime = this.$refs['video' + id].currentTime;
        this.$store.commit('setVideoProgress', currentTime);
      }
    },
    // 热门话题跳转
    toHotPage(item) {
      this.$router.push({
        name: 'subjectPage',
        query: {
          id: item.id,
          subjectName: item.subjectName,
          subjectType: item.subjectType,
          topicCommentNum: item.topicCommentNum,
          topicViewNum: item.topicViewNum
        }
      });
    },
    // 分享
    share() {
      console.log(111);
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
